import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

import { ExtendedWorkspaceListItem } from '@futrli/views/operations/workspaces/processors/workspacesList';

interface DatasourceFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
  workspaces?: ExtendedWorkspaceListItem[];
}

export const DatasourceFilter = ({ onChange, selectedValue, workspaces = [] }: DatasourceFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const options = useMemo(() => {
    const datasourceOptions = new Map<string, string>();

    workspaces.forEach(workspace => {
      workspace.organisations.forEach(organisation => {
        const key = organisation.integration?.slug;
        const label = organisation.integration?.name;

        if (key && label && !datasourceOptions.has(key)) {
          datasourceOptions.set(key, label);
        }
      });
    });

    const sortedDatasourceOptions = Array.from(datasourceOptions.entries())
      .map(([value, label]) => ({ value, label }))
      .sort((a, b) => a.label.localeCompare(b.label));

    return [
      {
        value: 'all',
        label: intl.formatMessage({ id: 'predict.filters.datasource.all', defaultMessage: 'All datasources' })
      },
      ...sortedDatasourceOptions
    ];
  }, [workspaces, intl]);

  return (
    <Box width={250}>
      <SimpleSelect
        label={intl.formatMessage({
          id: 'predict.filters.datasource.label',
          defaultMessage: 'Datasource'
        })}
        value={selectedValue}
        onChange={handleChange}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </SimpleSelect>
    </Box>
  );
};
